import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, Subject, config } from 'rxjs';
import { Usuarios, IUsuario } from './usuarios.model';
import { DataModel, IDataModel } from './data.model';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { Router, ActivatedRoute } from '@angular/router';
import { getTableNameFull } from './data.model';
import { OkDialog } from '../comum/custom-dialog.module';
import { MatDialog } from '@angular/material';
import { AngularFireDatabase } from 'angularfire2/database';


@Injectable()
export class UsersService {
    usuarioClass: Usuarios;
    nav_anterior = null;
    nav_ultimo = null;
    nav_dados = null;
    tmpUsuario: any;
    resultLogin;
    logado: boolean = false;
    aceitaAprovacaoPendente: boolean = false;
    fUsuario: any;
    limit: number = 20;
    first: number = 1;
    navChangeList: Subject<any> = new Subject<any>();
    loginChange: Subject<any> = new Subject<any>();
    mensagem: string = "";
    constructor(private db: AngularFirestore,
        private afAuth: AngularFireAuth,
        private af: AngularFireDatabase,
        private router: Router,
        private activeRouter: ActivatedRoute,
        private dialog: MatDialog) {
        this.usuarioClass = new Usuarios(db, this);

        let op = activeRouter.snapshot.params.op;
        if (op && op == 'off') {
            this.logout();
        }


    }

    get connection() {
        return this.db;
    }

    get regiaoLogada() {
        // usado para filtrar os cadastro por regiao regiaoLogada
        // DONE: alterado fornecedores.model
        // TODO: alterar o login para pegar a regiao e preencher esta propriedade
        return null;
    }

    get usuario() {
        if (this.logado) {
            return this.fUsuario;
        } else {
            if (this.aceitaAprovacaoPendente) {
                return this.fUsuario;
            } else
                alert("erro no login");
        }

    }

    canShow(menuPerfil): boolean {
        let rt = false;
        if (menuPerfil.indexOf("todos") >= 0) {
            rt = true;
        } else
            if (menuPerfil.indexOf("admin") >= 0) {
                rt = rt || this.isAdmin;
            }
        if (menuPerfil.indexOf("local") >= 0) {
            rt = rt || this.isLocal;
        }
        if (menuPerfil.indexOf("gestor") >= 0) {
            rt = rt || this.isGestor;
        }
        if (menuPerfil.indexOf("fornecedor") >= 0) {
            rt = rt || this.isFornecedor;
        }
        if (menuPerfil.indexOf("afiliado") >= 0) {
            rt = rt || this.isAfiliado;
        }
        if (menuPerfil.indexOf("vendedor") >= 0) {
            rt = rt || this.isVendedor;
        }

        return rt;
    }
    get fornecedor(): number {
        if (this.fUsuario)
            return this.fUsuario.fornecedor
        else return -1;
    }
    get codigo(): number {
        if (this.fUsuario)
            return parseFloat(this.fUsuario.codigo.toString());
    }
    get isLocal(): boolean {
        if (this.fUsuario)
            return this.fUsuario.perfil === "local";
        else return false;
    }
    get isGestor(): boolean {
        if (this.fUsuario)
            return this.fUsuario.perfil === "gestor";
        else return false;
    }
    get isFornecedor(): boolean {
        if (this.fUsuario)
            return this.fUsuario.perfil === "fornecedor";
        else return false;
    }
    get isAdmin(): boolean {
        if (this.fUsuario)
            return this.fUsuario.perfil === "admin";
        else return false;
    }

    get perfil() {
        if (this.fUsuario)
            return this.fUsuario.perfil;
        else return 'consumidor';
    }

    get isAfiliado(): boolean {
        if (this.fUsuario)
            return this.fUsuario.perfil === "afiliado";
        else return false;
    }

    get isVendedor(): boolean {
        if (this.fUsuario)
            return this.fUsuario.perfil === "vendedor";
        else return false;
    }

    getUsers(): any {
        let ref = this.db.collection(getTableNameFull("usuarios")).ref;
        let query = ref.orderBy("nome").limit(this.limit);
        query.get().then(r => {
            if (r.docs.length > 0) {
                this.nav_anterior = r.docs[0];
                this.nav_ultimo = r.docs[r.docs.length - 1];
                this.nav_dados = [];
                r.docs.forEach(element => {
                    this.nav_dados.push({ id: element.id, ...element.data() });
                });
                this.navChangeList.next(this.nav_dados);
            }
        })
    }

    getNext() {
        if (this.nav_ultimo) {
            let ref = this.db.collection(getTableNameFull("usuarios")).ref;
            let query = ref.orderBy("nome")
                .startAfter(this.nav_ultimo)
                .limit(this.limit);
            query.get().then(r => {
                if (r.docs.length > 0) {
                    this.nav_anterior = r.docs[0];
                    this.nav_ultimo = r.docs[r.docs.length - 1];
                    this.nav_dados = [];
                    r.docs.forEach(element => {
                        this.nav_dados.push({ id: element.id, ...element.data() });
                    });
                    this.navChangeList.next(this.nav_dados);
                } else {
                    this.nav_ultimo = null;
                }
            })
        } else {
            return this.getUsers();
        }
    }

    getPrior() {
        if (this.nav_ultimo) {
            let ref = this.db.collection(getTableNameFull("usuarios")).ref;
            let query = ref.orderBy("nome")
                .endAt(this.nav_ultimo)
                .limit(this.limit);
            query.get().then(r => {
                if (r.docs.length > 0) {
                    this.nav_anterior = r.docs[0];
                    this.nav_ultimo = r.docs[r.docs.length - 1];
                    this.nav_dados = [];
                    r.docs.forEach(element => {
                        this.nav_dados.push({ id: element.id, ...element.data() });
                    });
                    this.navChangeList.next(this.nav_dados);
                } else {
                    this.nav_ultimo = null;
                }
            })
        } else {
            return this.getUsers();
        }
    }

    procurarUsuario(email, proc, pErro?) {
        //console.log('procurando por: ', email);
        return this.usuarioClass.getUsuarioByEmail(
            email,
            r => {
                r.sucesso = r.length > 0;
                proc(r);
                return null;
            },
            pErro
        );
    }

    getUsuario(codigo:number, pSubscribe) {
        this.usuarioClass.getUsuario(codigo, pSubscribe);
    }

    trocarSenha(novaSenha: string): any {
        this.afAuth.auth.currentUser.updatePassword(novaSenha);//.then(rsp=>{
        return Promise.resolve('trocou a senha');
    }


    enviarSenhaPorEmail(email) {
        return this.afAuth.auth.sendPasswordResetEmail(email);
    }

    pedirConfirmacaoEmail() {
        this.afAuth.auth.currentUser.sendEmailVerification();
    }

    deleteLogin(email) {
        this.db.collection('nc-usuarios').ref.where('email', '==', email).get()
            .then(rsp => {
                if (!rsp.empty) {
                    const row = rsp.docs[0].data();
                    const id = rsp.docs[0].id;
                    if (row.uid) {
                        this.af.list('/users/' + row.uid).remove();
                    }
                }
            });
    }


    _setUsuarioUid(email, uid) {
        this.db.collection('nc-usuarios').ref.where('email', '==', email).get()
            .then(rsp => {
                if (!rsp.empty) {
                    const id = rsp.docs[0].id;
                    this.db.collection('nc-usuarios').doc(id)
                        .update({ uid: uid, emailVerified: this.afAuth.auth.currentUser.emailVerified });
                }
            });
    }

    login(authData: any, podeEntrarSemAprovacao: boolean = false) {
        try {
            this.tmpUsuario = authData;
            this.aceitaAprovacaoPendente = podeEntrarSemAprovacao;
            this.afAuth.auth
                .signInAndRetrieveDataWithEmailAndPassword
                (authData.email, authData.password)
                .then(r => {
                    //console.log(r);
                    let loginX = this.afAuth.auth.currentUser;
                    if (!loginX.emailVerified)
                        this.pedirConfirmacaoEmail();
                    /// o google cadastrou minusculoa, mas o usuario digitou maiusculo,
                    /// procurar no banco interno como foi digitado.
                    this.procurarUsuario(authData.email, r => {
                        if (r && r.length > 0) {
                            this.resultLogin = r[0];
                            DataModel.setUsuarioCorrente(r[0]);
                            if (!this.resultLogin.uid ||
                                !this.resultLogin.emailVerified ||
                                this.resultLogin.emailVerified != this.afAuth.auth.currentUser.emailVerified)
                                this._setUsuarioUid(authData.email, loginX.uid);
                            this.loginEvent(r[0]);
                        } else {
                            let msg = "Não econtrado ";
                            OkDialog.open(this.dialog, msg);

                        }
                    }, e => {
                        let msg = e.message;
                        OkDialog.open(this.dialog, msg);
                    });

                })
                .catch(error => {
                    console.log(error);
                    let msg = 'Não autorizado (' + error.message + ")";
                    if (error.code && error.code == 'auth/user-not-found') {
                        // checa se se cadastrado local
                        this.checaRecadastro(authData.email, authData.password);
                    }
                    OkDialog.open(this.dialog, msg + '[ tente novamente ]');



                })
        } catch (error) {
            let msg = 'Não autorizado (' + error.message + ")";
        };
    }

    checaRecadastro(email, pass) {
        // se estiver na base local, recadastrar;
        console.log('recadastrar');
        this.procurarUsuario(email, d => {
            console.log(d[0]);
            if (d.length > 0) {
                let usuario = d[0];
                if (usuario.aprovado) {
                    this.addUser({ email: email, password: pass });
                }
            }
        });
    }
    logout() {
        this.logado = false;
        this.afAuth.auth.signOut();
        this.logado = false;
    }

    loginEvent(r: any) {
        //console.log('LoginEvent');
        this.fUsuario = r;
        //console.log(r);
        if (r == null) { this.mensagem = "Usuario não encontrado" } else {
            if (!r.aprovado) { this.mensagem = "Aguardando aprovação do cadastro..." } else this.mensagem = "";
            if (r.inativo) this.mensagem += " Conta esta inativa.";
            this.logado = ((r.inativo === false) && ((r.aprovado) || this.aceitaAprovacaoPendente));
            if (this.logado)
                this.salvarLocal();
            if (this.logado)
                DataModel.setUsuarioCorrente(r);
            this.loginChange.next(r);
        }
    }

    initAuthListener() {  /// fica aguardando evento de autenticacao
        this.afAuth.authState.subscribe(
            user => {
                if (user) {
                    let loginX = this.afAuth.auth.currentUser;
                    if (loginX && loginX.email) {
                        this.resultLogin = user;
                        this.procurarUsuario(loginX.email, r => {
                            this.loginEvent(r[0]);
                        })
                    };
                } else {
                    this.logado = false;
                    this.loginChange.next(user);
                }
            }
        )
    }

   async addUser(user: any) {
        this.tmpUsuario = user
        this.afAuth.auth
            .createUserAndRetrieveDataWithEmailAndPassword(user.email, user.password)
            .then(r => {
                this.afAuth.auth.signInAndRetrieveDataWithEmailAndPassword(user.email, user.password)
                    .then(logadoUser => {
                        this.afAuth.auth.currentUser.sendEmailVerification();
                        let obj = new Usuarios(this.db, this);
                        user.inativo = false;  // aguardar aprovaçao
                        user.aprovado = false;
                        user.email = r.user.email;
                        user['password'] = null;
                        user['confirmPassword'] = null;
                        obj.add(user);
                        if (this.aceitaAprovacaoPendente) {
                            this.loginChange.next(user);
                        }
                    });
               return Promise.resolve(r);     
            })
            .catch(error => {
                alert(error);
                return Promise.reject(error);
            });
    }

    updateUser(user: IUsuario) {
        this.usuarioClass.post(user, d => {

        })
    }

    deleteUser(id: string) {
        this.usuarioClass.delete(id);
    }

    salvarLocal() {
        window.localStorage.setItem(getTableNameFull("login"), JSON.stringify(this.usuario));
    }
    carregarLocal() {
        return window.localStorage.getItem(getTableNameFull("login"));
    }

    validaLoginLocal() {
        let local = this.carregarLocal();
        this.aceitaAprovacaoPendente = true;
        if (local) {
            let j = JSON.parse(local);
            if (j) {
                this.resultLogin = j;
                DataModel.setUsuarioCorrente(j);
                this.logado = true;
                this.fUsuario = j;
                this.loginChange.next(j);
            }
            if (j && j.email)
                this.procurarUsuario(j.email, r => {
                    this.resultLogin = r[0];
                    DataModel.setUsuarioCorrente(r[0]);
                    this.fUsuario = r[0];
                    this.loginChange.next(r[0]);
                    this.salvarLocal();
                    //                this.loginEvent(r[0]);
                });
        }
    }

} 